import $ from 'jquery';

$(document).ready(() => {
	$('.entity__link').bind('mouseenter', function () {
		const $container = $(this).closest('.entity__container');
		const $entity = $(this).closest('.entity');
		$container.addClass('active');
		$entity.addClass('active');
	});
	$('.entity__link').bind('mouseleave', function () {
			const $container = $(this).closest('.entity__container');
			const $entity = $(this).closest('.entity');
			$container.removeClass('active');
			$entity.removeClass('active');
	});
});
